<div id="nexleader-wrapper">
  <div class="content animate-panel">
    <div class="row">
      <div class="col-md-12">
        <div class="hpanel m-n">
          <div class="panel-heading">
            <h3 class="panel-title">Archetype Report Discount Codes</h3>
          </div>
          <div class="panel-body">
            <p class="text-muted">
              Discount codes allow users to receive a discount when purchasing an
              IPSAT 2.0 Archetype Report. Codes are case-insensitive.
            </p>
            <button class="btn btn-primary" (click)="openCreateDiscount()">
              <i class="fa fa-plus"></i> Create Discount Code
            </button>
          </div>
          <table class="table table-striped">
            <thead>
              <tr>
                <th>Code</th>
                <th>Discount Type</th>
                <th>Amount</th>
                <th>Uses</th>
                <th>Status</th>
                <th>Actions</th>
              </tr>
            </thead>
            <tbody>
              <tr *ngFor="let discount of discounts">
                <td>
                  <strong>{{ discount.name }}</strong>
                </td>
                <td>{{ discount.discountType.name || 'Unknown' }}</td>
                <td>{{ discount._discountAmountString }}</td>
                <td>
                  {{ discount.currentUses }}
                  <span *ngIf="discount.maxUses">/ {{ discount.maxUses }}</span>
                  <span *ngIf="!discount.maxUses">(unlimited)</span>
                </td>
                <td>
                  <span
                    class="label"
                    [class.label-success]="discount.isActive"
                    [class.label-default]="!discount.isActive"
                  >
                    {{ discount.isActive ? 'Active' : 'Inactive' }}
                  </span>
                  <span
                    *ngIf="discount.expiresAt"
                    class="label label-info"
                    style="margin-left: 5px"
                  >
                    Expires: {{ discount.expiresAt | date : 'shortDate' }}
                  </span>
                  <span
                    *ngIf="discount.onePerUser"
                    class="label label-info"
                    style="margin-left: 5px"
                    title="Each user can redeem this code at most once"
                  >
                    Once per user
                  </span>
                  <span
                    *ngIf="discount.refreshOnly"
                    class="label label-warning"
                    style="margin-left: 5px"
                    title="Only applies to a post-coaching report refresh, not new purchases or upgrades"
                  >
                    Refresh only
                  </span>
                </td>
                <td>
                  <button
                    class="btn btn-danger btn-sm"
                    (click)="remove(discount)"
                  >
                    <i class="fa fa-trash"></i> Delete
                  </button>
                </td>
              </tr>
              <tr *ngIf="discounts.length === 0">
                <td colspan="6" class="text-center text-muted">
                  No discount codes found. Click "Create Discount Code" to add
                  one.
                </td>
              </tr>
            </tbody>
          </table>
        </div>
      </div>
    </div>
  </div>
</div>
